import React from 'react'
import PaperPage from 'src/components/organisms/whitepapers/PaperPage'
import thumbnail from 'src/images/whitepapers/commmune-customer-success2.png'

const paperInfo = {
  paperName: '今後5年の新潮流!「カスタマーサクセス2.0」\n徹底解説',
  thumbnail,
  feature1: 'カスタマーサクセス2.0とは何か',
  feature2: 'カスタマーサクセス2.0で事業成長を実現する5つのポイント',
  feature3: 'テクノロジーを活用したカスタマーサクセス2.0最新事例',
  description:
    '今後5年の新潮流として注目される「カスタマーサクセス2.0」とは何か、企業はどのように実現すべきか、社会的な背景や実際の事例も含めてご紹介をいたします。',
  formSrc: 'https://go.commmune.jp/l/915341/2021-03-10/jkc',
  type: 'pardot' // TODO: HubSpotからPardotに移行したらこのタグ付けが不要になるので削除する
}

const WhitePaper = () => {
  return <PaperPage {...paperInfo} />
}
export default WhitePaper
